module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-list"
  }, [_c('v-card', [(_vm.search && !_vm.pagination) ? _c('v-card-title', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1) : (_vm.search && _vm.pagination) ? _c('v-card-title', [_c('v-text-field', {
    attrs: {
      "append-icon": "clear",
      "append-icon-cb": _vm.searchClear,
      "prepend-icon": "search",
      "prepend-icon-cb": _vm.searchApi,
      "label": "Search",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchApi()
      }
    },
    model: {
      value: (_vm.searchTextApi),
      callback: function($$v) {
        _vm.searchTextApi = $$v
      },
      expression: "searchTextApi"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', _vm._b({
    attrs: {
      "mobile-breakpoint": "0",
      "items": _vm.items,
      "loading": _vm.loading,
      "search": _vm.searchText,
      "options": _vm.paginationVal,
      "no-data-text": _vm.noDataText,
      "multi-sort": false,
      "must-sort": false,
      "items-per-page": 25,
      "footer-props": {
        'items-per-page-options': [10, 25, 100]
      }
    },
    on: {
      "update:options": function($event) {
        _vm.paginationVal = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('tr', {
          class: _vm.rowClass(props.item),
          style: (_vm.rowStyle),
          on: {
            "click": function($event) {
              return _vm.editItem(props.item[_vm.id])
            }
          }
        }, [_vm._l((_vm.headers), function(header, i) {
          return [(header.function || header.itemValue) ? _c('td', {
            key: i,
            staticClass: "text-xs-left"
          }, [_vm._v("\n              " + _vm._s(_vm.computedFromContext[header.value][_vm.getElement(props.item, _vm.id)]) + "\n            ")]) : (header.type == 'checkbox') ? _c('td', {
            key: i
          }, [_c('v-checkbox', {
            staticStyle: {
              "width": "1px",
              "margin-top": "0px"
            },
            attrs: {
              "input-value": _vm.getElement(props.item, header.value),
              "disabled": "",
              "hide-details": ""
            }
          })], 1) : _c('td', {
            key: i,
            staticClass: "text-xs-left"
          }, [_vm._v("\n              " + _vm._s(_vm.getElement(props.item, header.value)) + "\n            ")])]
        }), _vm._v(" "), _vm._l((_vm.buttons), function(button, j) {
          return [_c('td', {
            key: j + 10000,
            staticStyle: {
              "width": "1%",
              "padding": "0px"
            }
          }, [_c('v-btn', {
            attrs: {
              "title": button.text,
              "icon": "",
              "text": ""
            },
            on: {
              "click": function($event) {
                return button.function(props.item)
              }
            }
          }, [_c('v-icon', [_vm._v(_vm._s(button.icon))])], 1)], 1)]
        }), _vm._v(" "), (_vm.allowDelete && _vm.canDelete) ? _c('td', {
          staticStyle: {
            "width": "1%",
            "padding": "0px"
          }
        }, [_c('v-btn', {
          attrs: {
            "title": "Delete",
            "icon": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteDialog(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()], 2)]
      }
    }])
  }, 'v-data-table', _vm.computedProps, false), [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "color": "blue",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "footer.prepend"
  }, [_vm._t("footer.prepend")], 2)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this " + _vm._s(_vm.name) + "?  This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteItem.apply(null, arguments)
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), (_vm.allowAdd && _vm.canCreate) ? _c('v-btn', {
    staticClass: "green mt-4",
    attrs: {
      "fab": "",
      "dark": "",
      "id": "addButton"
    },
    on: {
      "click": function($event) {
        return _vm.editItem('new')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28dac7d1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@sdgsystems/vue-common/components/ItemList.vue
// module id = 428
// module chunks = 1